export const rupiah = (n) => {
  const num = Number(n || 0);
  return "Rp " + Math.round(num).toLocaleString("id-ID");
};

export const rupiahShort = (n) => {
  const num = Number(n || 0);
  if (num >= 1_000_000) return "Rp " + (num / 1_000_000).toFixed(1) + "jt";
  if (num >= 1_000) return "Rp " + (num / 1_000).toFixed(0) + "rb";
  return "Rp " + num;
};

export const PRICE_LEVELS = [
  { key: "eceran", label: "Eceran", cls: "text-emerald-600 border-emerald-500/40 bg-emerald-500/10" },
  { key: "grosir", label: "Grosir", cls: "text-amber-600 border-amber-500/40 bg-amber-500/10" },
  { key: "member", label: "Member", cls: "text-indigo-400 border-indigo-500/40 bg-indigo-500/10" },
];

export const imgUrl = (image) => {
  if (!image) return "";
  return image.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL || ""}${image}` : image;
};

export const stockLabel = (stock, units, baseUnit = "Pcs") => {
  const s = Number(stock || 0);
  const larger = (units || []).filter((u) => Number(u.pieces) > 1).sort((a, b) => b.pieces - a.pieces)[0];
  if (!larger) return `${s} ${baseUnit}`;
  const big = Math.floor(s / larger.pieces);
  const rest = s % larger.pieces;
  if (big <= 0) return `${s} ${baseUnit}`;
  return `${s} ${baseUnit} · ${big} ${larger.name}${rest ? ` ${rest} ${baseUnit}` : ""}`;
};
